import { DeleteFileRequestContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to delete a file
 * @param request File deletion parameters
 * @returns Promise with void response
 */
export const deleteFileApi = async (request: DeleteFileRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/files/delete');
  return apiRequest(request);
};
